export default {
  setOnlineStatus(context, data) {
    context.commit('SET_ONLINE_STATUS', data);
  },
};
